var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ backgroundColor: '#f6f6f6' })},[_c('router-view'),_c('AppModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }